import { render } from "./SasepStatic.vue?vue&type=template&id=58032984&scoped=true"
import script from "./SasepStatic.vue?vue&type=script&lang=js"
export * from "./SasepStatic.vue?vue&type=script&lang=js"

import "./SasepStatic.vue?vue&type=style&index=0&id=58032984&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58032984"]])

export default __exports__